import { connect } from 'react-redux'
import changeUserEmailComponent from '../../components/profile/changeUserEmail.component'
import { closeProfileSnackbar, updateUserEmail } from '../../actions'
import { LOGOUT } from '../../constants'

const mapStateToProps = (state) => {
  const { client } = state
  const userType = client.user.data[5]
  const emailLoggedIn = client.user.data[1]
  return {
    state,
    userType,
    emailLoggedIn,
    updateUserEmailSuccess: state.profile.updateUserEmailSuccess,
    updateEmailFailedSnackbar: state.profile.updateEmailFailedSnackbar
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    updateUserEmail: (values) => dispatch(updateUserEmail(values)),
    closeProfileSnackbar: () => dispatch(closeProfileSnackbar()),
    handlemanuallogout: () => {
      dispatch({ type: LOGOUT })
    }
  }
}

const ChangeUserEmailContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(changeUserEmailComponent)

export default ChangeUserEmailContainer
